import React from 'react';
import { ExternalLink } from 'lucide-react';
import { Banner } from './Banner';
import { useNotifications } from '../hooks/useNotifications';
import { useDemo } from './demo/DemoProvider';

interface NotificationBannerManagerProps {
  position?: string;
}

export function NotificationBannerManager({ position = 'top-0' }: NotificationBannerManagerProps) {
  const {
    currentNotification,
    currentNotificationIndex,
    notifications,
    hasNotifications,
    dismissNotification,
    goToNextNotification,
    goToPreviousNotification,
  } = useNotifications();
  const { isDemo } = useDemo();

  // Don't show notifications when in demo mode
  if (!hasNotifications || !currentNotification || isDemo) {
    return null;
  }

  return (
    <Banner
      position={position}
      onClose={() => dismissNotification(currentNotification.id)}
      leftElement={
        notifications.length > 1 ? (
          <button
            onClick={goToPreviousNotification}
            className="p-1 px-2 rounded bg-white/90 text-[#E34290] hover:bg-white transition-colors text-[10px] sm:text-xs font-medium"
            aria-label="Previous notification"
          >
            ← {currentNotificationIndex + 1}/{notifications.length}
          </button>
        ) : null
      }
      rightElement={
        <>
          {currentNotification.link && (
            <a
              href={currentNotification.link}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center px-3 py-1 text-[10px] sm:text-xs font-medium bg-white text-[#E34290] hover:bg-white/90 rounded transition-colors"
            >
              Learn More
              <ExternalLink className="ml-1 h-3 w-3" />
            </a>
          )}
          {notifications.length > 1 && (
            <button
              onClick={goToNextNotification}
              className="p-1 px-2 rounded bg-white/90 text-[#E34290] hover:bg-white transition-colors ml-2 text-[10px] sm:text-xs font-medium"
              aria-label="Next notification"
            >
              →
            </button>
          )}
        </>
      }
    >
      {currentNotification.content}
    </Banner>
  );
}
